import * as RadixCheckbox from "@radix-ui/react-checkbox";
import { cn } from "../../lib/utils";

export interface CheckboxProps {
  id?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
  children?: React.ReactNode;
}

export function Checkbox({ id, checked, onCheckedChange, className, children }: CheckboxProps) {
  return (
    <label htmlFor={id} className={cn("flex items-start gap-3 cursor-pointer text-sm text-muted-foreground", className)}>
      <RadixCheckbox.Root
        id={id}
        checked={checked}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        className="mt-0.5 h-5 w-5 shrink-0 rounded-md border border-border bg-white data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40"
      >
        <RadixCheckbox.Indicator className="flex items-center justify-center text-white">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      <span className="leading-snug">{children}</span>
    </label>
  );
}
